import { Box } from "@mui/material";
import BackHomeButton from "../../components/version1/BackHomeButton";
import JoinGroupButton from "../../components/version1/JoinGroupButton";
import MainContent from "../../components/version1/MainContent";
import PromoSlider from "../../components/version1/PromoSlider";

const PromoPageV1: React.FC = () => {
  return (
    <Box
  sx={{
    backgroundImage: {
      xs: "url('/bg-mobile.png')", // 📱 มือถือ
      md: "url('/bg-new88.webp')",    // 🖥 เดสก์ท็อป
    },
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: { xs: "scroll", md: "fixed" }, // mobile scroll, pc fixed
    width: "100vw",
    minHeight: "100vh",
    overflowX: "hidden",
  }}
>
  <BackHomeButton />
  <JoinGroupButton />

  {/* ✅ เนื้อหาหลัก */}
  <MainContent />

  <PromoSlider />
</Box>

  );
};

export default PromoPageV1;
